import { render } from "./ProspectHistoryDetail.vue?vue&type=template&id=17644df2"
import script from "./ProspectHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ProspectHistoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__